/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import OrganizationDtoAndRoleObjectDto from './OrganizationDtoAndRoleObjectDto';

/**
 * The UserDto model module.
 * @module model/UserDto
 * @version v1.0.0
 */
class UserDto {
    /**
     * Constructs a new <code>UserDto</code>.
     * @alias module:model/UserDto
     */
    constructor() { 
        
        UserDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>UserDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UserDto} obj Optional instance to populate.
     * @return {module:model/UserDto} The populated <code>UserDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UserDto();

            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('mainOrganizationId')) {
                obj['mainOrganizationId'] = ApiClient.convertToType(data['mainOrganizationId'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('organizations')) {
                obj['organizations'] = ApiClient.convertToType(data['organizations'], [OrganizationDtoAndRoleObjectDto]);
            }
        }
        return obj;
    }


}

/**
 * user description
 * @member {String} description
 */
UserDto.prototype['description'] = undefined;

/**
 * user email
 * @member {String} email
 */
UserDto.prototype['email'] = undefined;

/**
 * user id
 * @member {Number} id
 */
UserDto.prototype['id'] = undefined;

/**
 * main organization id
 * @member {Number} mainOrganizationId
 */
UserDto.prototype['mainOrganizationId'] = undefined;

/**
 * user name
 * @member {String} name
 */
UserDto.prototype['name'] = undefined;

/**
 * organization with role
 * @member {Array.<module:model/OrganizationDtoAndRoleObjectDto>} organizations
 */
UserDto.prototype['organizations'] = undefined;






export default UserDto;

